module.exports = __webpack_public_path__ + "static/text-5-e10de74601a750d22ba5b80b2c8cbb0c.svg";